import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, take, tap } from 'rxjs';
import { SelectedLocation } from '../interfaces';
import { LocalStorageKey } from '../enums';

@Injectable({ providedIn: 'root' })
export class LocationStorage {
  private readonly locationSubject: BehaviorSubject<SelectedLocation | null> =
    new BehaviorSubject<SelectedLocation | null>(this.readFromStorage());

  readonly location$: Observable<SelectedLocation | null> = this.locationSubject.asObservable();

  get location(): SelectedLocation | null {
    return this.locationSubject.value;
  }

  setLocation(location: SelectedLocation): Observable<void> {
    return this.location$.pipe(
      take(1),
      tap(() => {
        this.locationSubject.next(location);
        localStorage.setItem(LocalStorageKey.SelectedLocation, JSON.stringify(location));
      }),
      map(() => void 0)
    );
  }

  clearLocation(): void {
    this.locationSubject.next(null);
    localStorage.removeItem(LocalStorageKey.SelectedLocation);
  }

  private readFromStorage(): SelectedLocation | null {
    try {
      const raw: string | null = localStorage.getItem(LocalStorageKey.SelectedLocation);
      return raw ? (JSON.parse(raw) as SelectedLocation) : null;
    } catch {
      return null;
    }
  }
}
